// extracted by mini-css-extract-plugin
module.exports = {"wide-card":"styles_wide-card__3DC7L"};